import { useState } from 'react';

import { useServerClient } from '../useServerClient';
import { useServerParams, _operatorDef as filterOperatorTypes } from '../useServerParams';

export const defaultTypes = {
    email_gateway: {
        id: "email_gateway",
        key: "email_gateway",
    },
    sms_gateway: {
        id: "sms_gateway",
        key: "sms_gateway",
    },
    whatsapp_gateway: {
        id: "whatsapp_gateway",
        key: "whatsapp_gateway",
    },
}

export const defaultSettings = {
    email_gateway: {
        default: {
            id: `default`,
            key: `eg_selection`,
            props: {
                settingKey: 'selection_key',
            }
        },
        smtp: {
            id: `smtp`,
            key: `eg_smtp`,
            props: {
                username: 'username',
                password: 'password',
                hostPort: 'smtp_port',
                hostUrl: 'smtp_host',
                fromEmail: 'from_email',
                fromName: 'from_name',
                replyEmail: 'reply_email',
                replyName: 'reply_name',
            }
        },
        mailjet: {
            id: `mailjet`,
            key: `eg_mailjet`,
            props: {
                apiEndpoint: 'api_endpoint',
                apiSecret: 'api_secret',
                apiKey: 'api_key',
                fromEmail: 'from_email',
                fromName: 'from_name',
                replyEmail: 'reply_email',
                replyName: 'reply_name',
            }
        },
    },
    sms_gateway: {
        default: {
            id: `default`,
            key: `sg_selection`,
            props: {
                settingKey: 'selection_key',
            }
        },
        isms: {
            id: `isms`,
            key: `sg_isms`,
            props: {
                endpointUrl: 'api_endpoint',
                username: 'username',
                password: 'password',
                type: 'type',
                sendId: 'send_id',
            }
        },
    },
    whatsapp_gateway: {
        default: {
            id: `default`,
            key: `wg_selection`,
            props: {
                settingKey: 'selection_key',
            }
        },
        isms: {
            id: `isms`,
            key: `wg_isms`,
            props: {
                endpointUrl: 'api_endpoint',
                username: 'username',
                password: 'password',
                type: 'type',
                sendId: 'send_id',
            }
        },
    }
}

export function getCreatePayload({
    typeId,
    typeName = '',
    settingId,
    settingName = '',
    overrideSettingKey = '', // force use the key - override
    props
}) {

    let fields = props.map(i => {
        return {
            field_key: `${i?.key}`,
            field_label: `${i?.label}`,
            field_value: `${i?.value}`
        }
    })

    let settingKey = `${overrideSettingKey}`

    if (settingId) {
        settingKey = `${defaultSettings[typeId][settingId]?.key}`
    }

    return {
        setting_type: `${typeId}`,
        setting_title: `${typeName}`,
        setting_key: `${settingKey}`,
        setting_label: `${settingName}`,
        fields
    }

}

export function getListFilters({
    typeKey,
    settingKey,
    settingKeys = [],
    fieldKeys = []
}) {

    let filters = []

    filters.push({
        name: "setting_type",
        operator: filterOperatorTypes.eq,
        value: typeKey,
    })

    if (settingKeys) {
        filters.push({
            name: "setting_key",
            operator: filterOperatorTypes.eq,
            value: settingKey,
        })
    }

    if (settingKeys.length > 0) {
        filters.push({
            name: "setting_key",
            operator: filterOperatorTypes.anyOf,
            value: JSON.stringify(settingKeys),
        })
    }

    if (fieldKeys.length > 0) {
        filters.push({
            name: "field_key",
            operator: filterOperatorTypes.anyOf,
            value: JSON.stringify(fieldKeys),
        })
    }

    return filters

}

export function useSettings({ 
    // _typeIds = []
    typeIds: _typeIds 
}) {

    const [typeIds, setTypeIds] = useState(_typeIds);
    // const [targetType, setTargetType] = useState(_targetType);

    const { makeCall, getError } = useServerClient();
    const { getListsUrl, getUrlWithDataTypes, _operatorDef: filterOperatorTypes } = useServerParams();

    const [isLoading, setIsLoading] = useState(false)

    const endpoint1 = "setting";
    const endpoint2 = "settings/setting"

    const list = async (props) => {

        setIsLoading(true);

        try {

            let url = getListsUrl(`${endpoint2}`, props);

            const response = await makeCall({
                url,
                method: "GET",
                payload: {}
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }
    }

    const create = async ({
        data,
    }) => {

        setIsLoading(true)

        try {

            let url = `${endpoint1}`;

            let putData = {
                scope: {
                    target: 'setting',
                    action: "",
                },
                payload: data
            }

            const response = await makeCall({
                url,
                method: "PUT",
                payload: putData
            });

            setIsLoading(false);

            return response;

        } catch (error) {

            setIsLoading(false);
            throw error;

        }

    }

    return {
        isLoading,
        filterOperatorTypes,
        typeIds,
        list,
        create,
    }
}